import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import DataTableLayout from "layouts/DatatableLayout";
import { Stack, Tooltip, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import StoreIcon from "@mui/icons-material/Store";
import BrandingWatermarkIcon from "@mui/icons-material/BrandingWatermark";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "moment/locale/th"; // ใส่ locale ไทย
import { getPrefixName, filterTextAndNum } from "utils/HelperFunction";
import { getReportBrandallSummary } from "../../redux/handlers/report/getReportBrandallSummary.handler";
import { getReportBrandall } from "../../redux/handlers/report/getReportBrandall.handler";
import { getAllMstBusiness } from "../../redux/handlers/master/getAllMstBusiness.handler";
import { getAllMstBrand } from "../../redux/handlers/master/getAllMstBrand.handler";
export function ReportBrandSummary() {
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), datalist = _useState[0], setDatalist = _useState[1];
    var _useState1 = _sliced_to_array(useState({}), 2), summary = _useState1[0], setSummary = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), businessid = _useState2[0], setBusinessid = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), optionBus = _useState3[0], setOptionBus = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), optionBrand = _useState4[0], setOptionBrand = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), brandId = _useState5[0], setBrandId = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), filterText = _useState6[0], setFilterText = _useState6[1];
    var getReportBrandallReducer = useAppSelector(function(state) {
        return state.getReportBrandallReducer;
    });
    var getReportBrandallSummaryReducer = useAppSelector(function(state) {
        return state.getReportBrandallSummaryReducer;
    });
    var getAllMstBusinessReducer = useAppSelector(function(state) {
        return state.getAllMstBusinessReducer;
    });
    var getAllMstBrandReducer = useAppSelector(function(state) {
        return state.getAllMstBrandReducer;
    });
    useEffect(function() {
        dispatch(getAllMstBusiness());
        dispatch(getAllMstBrand());
    }, []);
    useEffect(function() {
        dispatch(getReportBrandall({
            businessid: parseInt(businessid),
            brandid: parseInt(brandId),
            productname: filterText
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getReportBrandallSummary({
            businessid: parseInt(businessid),
            brandid: parseInt(brandId),
            productname: filterText
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        businessid,
        brandId,
        filterText
    ]);
    useEffect(function() {
        setIsLoading(getReportBrandallReducer.isFetching || getReportBrandallSummaryReducer.isFetching || getAllMstBusinessReducer.isFetching || getAllMstBrandReducer.isFetching);
        if (getReportBrandallReducer.data) {
            var _getReportBrandallReducer_data;
            setDatalist(getReportBrandallReducer === null || getReportBrandallReducer === void 0 ? void 0 : (_getReportBrandallReducer_data = getReportBrandallReducer.data) === null || _getReportBrandallReducer_data === void 0 ? void 0 : _getReportBrandallReducer_data.data);
        }
        if (getReportBrandallSummaryReducer.data) {
            setSummary(getReportBrandallSummaryReducer.data.data);
        }
        if (getAllMstBusinessReducer.data) {
            var arr = [
                {
                    value: null,
                    label: "ทั้งหมด"
                }
            ];
            getAllMstBusinessReducer.data.data.map(function(ele) {
                return arr.push({
                    value: ele.bus_business_id,
                    label: ele.bus_business_businesstype == 1 ? getPrefixName(ele.bus_business_prefixid) + filterTextAndNum(ele.bus_business_fname) + " " + filterTextAndNum(ele.bus_business_lname) : ele.bus_business_businesstype == 2 ? filterTextAndNum(ele.bus_business_comprefixname) + " " + filterTextAndNum(ele.bus_business_name) + " " + filterTextAndNum(ele.bus_business_suffixname) : filterTextAndNum(ele.bus_business_name)
                });
            });
            setOptionBus(arr);
        }
        if (getAllMstBrandReducer.data) {
            var dataBrandNew = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            getAllMstBrandReducer.data.data.map(function(ele) {
                return dataBrandNew.push({
                    label: ele.set_brand_name,
                    value: ele.set_brand_id
                });
            });
            setOptionBrand(dataBrandNew);
        }
    }, [
        getReportBrandallReducer,
        getReportBrandallSummaryReducer,
        getAllMstBusinessReducer,
        getAllMstBrandReducer
    ]);
    var columns = [
        {
            name: "ชื่อธุรกิจ (Partner)",
            width: "220px",
            selector: function(row) {
                return (row === null || row === void 0 ? void 0 : row.bus_business_name) || "-";
            }
        },
        {
            name: "แบรนด์",
            width: "220px",
            selector: function(row) {
                return (row === null || row === void 0 ? void 0 : row.set_brand_name) || "-";
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "body1",
                            children: row.set_brand_name || "-"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "body2",
                            children: row.set_brand_namela || ""
                        })
                    ]
                });
            }
        },
        {
            name: "SKU (สินค้า)",
            selector: function(row) {
                return row.pd_product_name_th || "-";
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "body1",
                            children: row.pd_product_name_th || "-"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "body2",
                            children: row.pd_product_name_ens || ""
                        })
                    ]
                });
            }
        },
        {
            name: "ประเภทสินค้า",
            width: "220px",
            selector: function(row) {
                return (row === null || row === void 0 ? void 0 : row.set_producttype_name) || "-";
            }
        },
        {
            name: "หมวดหมู่หลัก",
            width: "220px",
            selector: function(row) {
                return (row === null || row === void 0 ? void 0 : row.set_productcategory_name) || "-";
            }
        },
        {
            name: "หมวดหมู่ย่อย",
            width: "220px",
            selector: function(row) {
                return (row === null || row === void 0 ? void 0 : row.set_productcategorysub_name) || "-";
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงานสรุปแบรนด์"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานสรุปแบรนด์"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-2 col-md-4",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card card-st-3 mb-4 !bg-[#d5eafa] !text-[#000]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: !isMobile ? "fs-20 mb-2" : "fs-18 mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "me-2",
                                                children: /*#__PURE__*/ _jsx(StoreIcon, {})
                                            }),
                                            "จำนวนธุรกิจ"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 mb-2 text-right",
                                        children: (summary === null || summary === void 0 ? void 0 : summary.total_business) || 0
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-2 col-md-4",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card card-st-3 mb-4 !bg-[#d4f3cd] !text-[#000]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: !isMobile ? "fs-20 mb-2" : "fs-18 mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "me-2",
                                                children: /*#__PURE__*/ _jsx(BrandingWatermarkIcon, {})
                                            }),
                                            "จำนวนแบรนด์"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 mb-2 text-right",
                                        children: (summary === null || summary === void 0 ? void 0 : summary.total_brand) || 0
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-2 col-md-4",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card card-st-3 mb-4 !bg-[#d4f3cd] !text-[#000]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: !isMobile ? "fs-20 mb-2" : "fs-18 mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "me-2",
                                                children: /*#__PURE__*/ _jsx(Inventory2Icon, {})
                                            }),
                                            "จำนวน SKU"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 mb-2 text-right",
                                        children: (summary === null || summary === void 0 ? void 0 : summary.total_product) || 0
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-xl-3 pb-0",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-xl-4",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-4",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาแบรนด์"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาแบรนด์",
                                                options: optionBrand,
                                                value: optionBrand.find(function(opt) {
                                                    return opt.value === brandId;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setBrandId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-4",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาจากธุรกิจ"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาจากธุรกิจ",
                                                options: optionBus,
                                                value: optionBus.find(function(opt) {
                                                    return opt.value === businessid;
                                                }) || optionBus[0] || null,
                                                onChange: function(e) {
                                                    setBusinessid(e.value);
                                                }
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-4",
                                    children: /*#__PURE__*/ _jsx(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: /*#__PURE__*/ _jsx("input", {
                                            type: "text",
                                            className: "form-control form-st-4 py-2 w-100",
                                            placeholder: "ค้นหาชื่อสินค้า",
                                            onChange: function(e) {
                                                return setFilterText(e.target.value);
                                            },
                                            value: filterText
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-0 py-0",
                        children: /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: datalist,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    })
                ]
            })
        ]
    });
}
